import Backbone from 'backbone'
import _ from 'lodash'

var license = {

	// sets the data for the license for the current
	set: function(lic) {
		_.extend(this, lic)
	},

	// unsets information about the current license
	remove: function() {
		license.valid = false
	}

}

Backbone.on('load update:license', function(data) {
	if (data.license) {
		license.set(data.license)
	}
})

export default license

license.__filename__ = 'components/license.js'
